import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'Descarga y Diagnóstico',
  desc: 'Descargas el Protocolo y realizas el auto-diagnóstico de energía.'
}, {
  num: '2',
  title: 'Reset OMH Diario',
  desc: 'Aplicas el Reset OMH de 5 minutos cada mañana (sin equipo).'
}, {
  num: '3',
  title: 'Nutrición de Vigor',
  desc: 'Sigues la Guía de Nutrición de Alto Vigor para alimentar tus hormonas, no tu grasa.'
}];
export function HowItWorks() {
  return <section className="py-16 md:py-24 px-6 bg-brand-dark" data-id="element-77">
      <div className="max-w-5xl mx-auto" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-79">
          <h2 className="font-heading font-bold text-4xl md:text-5xl text-brand-text uppercase" data-id="element-80">
            Cómo <span className="text-brand-accent" data-id="element-81">Funciona</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-82">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-brand-surface z-0" aria-hidden="true" data-id="element-83" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-84">
              <div className="w-24 h-24 rounded-full bg-brand-surface border-4 border-brand-dark flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(212,160,23,0.15)]" data-id="element-85">
                <span className="font-heading font-bold text-4xl text-brand-accent" data-id="element-86">
                  {step.num}
                </span>
              </div>
              <h3 className="font-heading font-bold text-2xl text-brand-text uppercase mb-3" data-id="element-87">
                {step.title}
              </h3>
              <p className="font-body text-brand-muted leading-relaxed" data-id="element-88">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}